import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Check, AlertCircle, Loader } from "lucide-react";
import { API } from "../lib/api";

const Unsubscribe = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true, ok: false, message: "", email: "" });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, ok: false, message: "Geen geldige link.", email: "" });
      return;
    }
    axios
      .get(`${API}/newsletter/unsubscribe`, { params: { token } })
      .then((r) => setState({ loading: false, ok: true, message: r.data.message, email: r.data.email }))
      .catch((err) => {
        const msg = err?.response?.data?.detail || "Afmelden mislukt.";
        setState({ loading: false, ok: false, message: msg, email: "" });
      });
  }, [token]);

  return (
    <div data-testid="unsubscribe-page" className="min-h-[60vh] flex items-center justify-center px-5 py-20">
      <div className="w-full max-w-md text-center">
        <div className="text-xs font-mono-x tracking-[0.3em] text-[var(--tha-red)] mb-4">
          UITSCHRIJVEN
        </div>

        {state.loading ? (
          <>
            <Loader size={28} className="mx-auto animate-spin text-[var(--tha-muted)]" />
            <div className="mt-6 font-display text-3xl">EVEN GEDULD...</div>
          </>
        ) : state.ok ? (
          <>
            <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-[var(--tha-red)] rounded-full mb-6">
              <Check size={24} className="text-[var(--tha-red)]" />
            </div>
            <h1 className="font-display text-4xl sm:text-5xl leading-none">
              JAMMER, MAAR <span className="neon-red-text">OKÉ.</span>
            </h1>
            <p className="mt-5 text-[var(--tha-muted)] text-sm">
              {state.email} is succesvol afgemeld voor de nieuwsbrief. We sturen je geen mailtjes meer.
            </p>
          </>
        ) : (
          <>
            <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-[var(--tha-muted)] rounded-full mb-6">
              <AlertCircle size={24} className="text-[var(--tha-muted)]" />
            </div>
            <h1 className="font-display text-4xl sm:text-5xl leading-none">OEPS.</h1>
            <p className="mt-5 text-[var(--tha-muted)] text-sm">{state.message}</p>
          </>
        )}

        <Link
          to="/"
          className="btn-ghost-red mt-10 inline-block px-6 py-3 font-display tracking-wider text-sm"
        >
          TERUG NAAR DE SITE
        </Link>
      </div>
    </div>
  );
};

export default Unsubscribe;
